import React, { useEffect, useState } from "react";
import { API } from "../../Redux/actions/API";
import Navbar from "../Navbar/Navbar";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { updateAuth } from "../../Redux/actions/AdminAuthSlice";

function Dashboard() {
  const { userId, jwt_token } = useSelector((state) => state.Auth);
  //console.log("uid", userId);

  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [dash, setDash] = useState([]);

  const Dashboard_API = async () => {
    try {
      let responceRight = await API?.get(
        `/admindashboarddata?loginid=${userId}`,
        {
          headers: {
            Authorization: jwt_token,
          },
        },
      );
      responceRight = responceRight.data.data[0][0];
      console.log("Dashboard--->", responceRight);
      setDash(responceRight);
    } catch (e) {
      console.log("error Balance APi", e);
      if (
        e.response.data.showableMessage ==
        "Please login to access this resource"
      ) {
        dispatch(updateAuth({ AdminAuth: false, jwt_token: "", userId: null }));
        sessionStorage.clear();
        localStorage.clear();
        navigate("/");
      }
    }
  };

  useEffect(() => {
    Dashboard_API();
  }, []);

  return (
    <div>
      <Navbar />
      {/* {AdminRole.adminrole == "Admin" ? ( */}
      <>
        <div id="wrapper">
          <div class="content-page page_scroll_y">
            <div class="content">
              <div class="container">
                <div class="row">
                  <div class="col-md-6">
                    <div class="box features-1">
                      <div class="gen-comp-plan">
                        <a href="Member_Details">
                          <div class="gcp-description">
                            <div class="gcp-title">Total Registration</div>
                            <div class="gcp-income">
                              <span class="cur1">{dash.totalUser}</span>
                            </div>
                          </div>
                        </a>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="box features-1">
                      <div class="gen-comp-plan">
                        <a href="Member_Details">
                          <div class="gcp-description">
                            <div class="gcp-title">Today's Registration</div>
                            <div class="gcp-income">
                              <span class="cur1">{dash.todayUser}</span>
                            </div>
                          </div>
                        </a>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="box features-1">
                      <div class="gen-comp-plan">
                        <a href="Member_Details">
                          <div class="gcp-description">
                            <div class="gcp-title">Total Activation</div>
                            <div class="gcp-income">
                              <span class="cur1">{dash.totalactivation}</span>
                            </div>
                          </div>
                        </a>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="box features-1">
                      <div class="gen-comp-plan">
                        <a href="Member_Details">
                          <div class="gcp-description">
                            <div class="gcp-title">Today's Activation</div>
                            <div class="gcp-income">
                              <span class="cur1">{dash.todayactivation}</span>
                            </div>
                          </div>
                        </a>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="box features-1">
                      <div class="gen-comp-plan">
                        <a href="/Activationhistory">
                          <div class="gcp-description">
                            <div class="gcp-title">
                              Total Trading Revenue Subcription
                            </div>
                            <div class="gcp-income">
                              <span class="cur1">
                                {" "}
                                {dash.TradingRevenueSub}
                              </span>
                            </div>
                          </div>
                        </a>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="box features-1">
                      <div class="gen-comp-plan">
                        <a href="/Activationhistory">
                          <div class="gcp-description">
                            <div class="gcp-title">
                              Today's Trading Revenue Subcription
                            </div>
                            <div class="gcp-income">
                              <span class="cur1">
                                {" "}
                                {dash.T_TradingRevenueSub}
                              </span>
                            </div>
                          </div>
                        </a>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <a href="/ActivationhistoryPlanB">
                      <div class="box features-1">
                        <div class="gen-comp-plan">
                          <div class="gcp-description">
                            <div class="gcp-title">
                              Total One Time Profit Subcription
                            </div>
                            <div class="gcp-income">
                              <span class="cur1">{dash.OneTimeProfitSub}</span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </a>
                  </div>
                  <div class="col-md-6">
                    <a href="/ActivationhistoryPlanB">
                      <div class="box features-1">
                        <div class="gen-comp-plan">
                          <div class="gcp-description">
                            <div class="gcp-title">
                              Today One Time Profit Subcription
                            </div>
                            <div class="gcp-income">
                              <span class="cur1">
                                {dash.T_OneTimeProfitSub}
                              </span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </a>
                  </div>
                  <div class="col-md-6">
                    <a href="/ActivationUHistoryStake">
                      <div class="box features-1">
                        <div class="gen-comp-plan">
                          <div class="gcp-description">
                            <div class="gcp-title">
                              Total Staking Subcription
                            </div>
                            <div class="gcp-income">
                              <span class="cur1">
                                {dash.StakingSubcription}
                              </span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </a>
                  </div>
                  <div class="col-md-6">
                    <a href="/ActivationUHistoryStake">
                      <div class="box features-1">
                        <div class="gen-comp-plan">
                          <div class="gcp-description">
                            <div class="gcp-title">
                              Today Staking Subcription
                            </div>
                            <div class="gcp-income">
                              <span class="cur1">
                                {dash.T_StakingSubcription}
                              </span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </a>
                  </div>
                  {/* <div class="col-md-6">
                    <a href="Level_Income">
                      <div class="box features-1">
                        <div class="gen-comp-plan">
                          <div class="gcp-description">
                            <div class="gcp-title">Total old Subcription</div>
                            <div class="gcp-income">
                              <span class="cur1">{dash.OldSubcription}</span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </a>
                  </div>
                  <div class="col-md-6">
                    <a href="Level_Income">
                      <div class="box features-1">
                        <div class="gen-comp-plan">
                          <div class="gcp-description">
                            <div class="gcp-title">Today old Subcription</div>
                            <div class="gcp-income">
                              <span class="cur1">{dash.T_OldSubcription}</span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </a>
                  </div>
                  <div class="col-md-6">
                    <a href="Level_Income">
                      <div class="box features-1">
                        <div class="gen-comp-plan">
                          <div class="gcp-description">
                            <div class="gcp-title">Total Subcription</div>
                            <div class="gcp-income">
                              <span class="cur1">{dash.totalSubcription}</span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </a>
                  </div>
                  <div class="col-md-6">
                    <a href="Level_Income">
                      <div class="box features-1">
                        <div class="gen-comp-plan">
                          <div class="gcp-description">
                            <div class="gcp-title">Today Total Subcription</div>
                            <div class="gcp-income">
                              <span class="cur1">{dash.T_totalSubcription}</span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </a>
                  </div> */}
                  <div class="col-md-6">
                    <div class="box features-1">
                      <div class="gen-comp-plan">
                        <a href="/TradingRevenueBonus">
                          <div class="gcp-description">
                            <div class="gcp-title">
                              Total Trading Revenue Bonus
                            </div>
                            <div class="gcp-income">
                              <span class="cur1">
                                {" "}
                                {dash.TradingRevenueBonus}
                              </span>
                            </div>
                          </div>
                        </a>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="box features-1">
                      <div class="gen-comp-plan">
                        <a href="/TradingRevenueBonus">
                          <div class="gcp-description">
                            <div class="gcp-title">
                              Today Trading Revenue Bonus
                            </div>
                            <div class="gcp-income">
                              <span class="cur1">
                                {dash.T_TradingRevenueBonus}
                              </span>
                            </div>
                          </div>
                        </a>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="box features-1">
                      <div class="gen-comp-plan">
                        <a href="/OneTimeProfitBonus">
                          <div class="gcp-description">
                            <div class="gcp-title">
                              Total One Time Profit Bonus
                            </div>
                            <div class="gcp-income">
                              <span class="cur1">
                                {" "}
                                {dash.OneTimeProfitBonus}
                              </span>
                            </div>
                          </div>
                        </a>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="box features-1">
                      <div class="gen-comp-plan">
                        <a href="/OneTimeProfitBonus">
                          <div class="gcp-description">
                            <div class="gcp-title">
                              Today One Time Profit Bonus
                            </div>
                            <div class="gcp-income">
                              <span class="cur1">
                                {dash.T_OneTimeProfitBonus}
                              </span>
                            </div>
                          </div>
                        </a>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="box features-1">
                      <div class="gen-comp-plan">
                        <a href="/Stakeincome">
                          <div class="gcp-description">
                            <div class="gcp-title">Total Staking Bonus</div>
                            <div class="gcp-income">
                              <span class="cur1"> {dash.StakingBonus}</span>
                            </div>
                          </div>
                        </a>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="box features-1">
                      <div class="gen-comp-plan">
                        <a href="/Stakeincome">
                          <div class="gcp-description">
                            <div class="gcp-title">Today Staking Bonus</div>
                            <div class="gcp-income">
                              <span class="cur1">{dash.T_StakingBonus}</span>
                            </div>
                          </div>
                        </a>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="box features-1">
                      <div class="gen-comp-plan">
                        <a href="/LevelIncome">
                          <div class="gcp-description">
                            <div class="gcp-title">
                              Total Trading Revenue Inroduction Bonus
                            </div>
                            <div class="gcp-income">
                              <span class="cur1">
                                {" "}
                                {dash.TradingRevenueInroBonus}
                              </span>
                            </div>
                          </div>
                        </a>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="box features-1">
                      <div class="gen-comp-plan">
                        <a href="/LevelIncome">
                          <div class="gcp-description">
                            <div class="gcp-title">
                              Today Trading Revenue Inroduction Bonus
                            </div>
                            <div class="gcp-income">
                              <span class="cur1">
                                {dash.T_TradingRevenueInroBonus}
                              </span>
                            </div>
                          </div>
                        </a>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="box features-1">
                      <div class="gen-comp-plan">
                        <a href="/LevelIncomePlanB">
                          <div class="gcp-description">
                            <div class="gcp-title">
                              Total One Time Profit Inroduction Bonus
                            </div>
                            <div class="gcp-income">
                              <span class="cur1">
                                {" "}
                                {dash.OneTimeProfitInroBonus}
                              </span>
                            </div>
                          </div>
                        </a>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="box features-1">
                      <div class="gen-comp-plan">
                        <a href="/LevelIncomePlanB">
                          <div class="gcp-description">
                            <div class="gcp-title">
                              Today One Time Profit Inroduction Bonus
                            </div>
                            <div class="gcp-income">
                              <span class="cur1">
                                {dash.T_OneTimeProfitInroBonus}
                              </span>
                            </div>
                          </div>
                        </a>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="box features-1">
                      <div class="gen-comp-plan">
                        <a href="/RoiIncomePlanB">
                          <div class="gcp-description">
                            <div class="gcp-title">
                              Total Staking Inroduction Bonus
                            </div>
                            <div class="gcp-income">
                              <span class="cur1"> {dash.StakingInroBonus}</span>
                            </div>
                          </div>
                        </a>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="box features-1">
                      <div class="gen-comp-plan">
                        <a href="/RoiIncomePlanB">
                          <div class="gcp-description">
                            <div class="gcp-title">
                              Today Staking Inroduction Bonus
                            </div>
                            <div class="gcp-income">
                              <span class="cur1">
                                {dash.T_StakingInroBonus}
                              </span>
                            </div>
                          </div>
                        </a>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="box features-1">
                      <div class="gen-comp-plan">
                        <a href="/TeamReward_income">
                          <div class="gcp-description">
                            <div class="gcp-title">
                              Total Leadership Performance Bonus
                            </div>
                            <div class="gcp-income">
                              <span class="cur1">
                                {" "}
                                {dash.LeadershipPerformanceBonus}
                              </span>
                            </div>
                          </div>
                        </a>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="box features-1">
                      <div class="gen-comp-plan">
                        <a href="/TeamReward_income">
                          <div class="gcp-description">
                            <div class="gcp-title">
                              Today Leadership Performance Bonus
                            </div>
                            <div class="gcp-income">
                              <span class="cur1">
                                {dash.T_LeadershipPerformanceBonus}
                              </span>
                            </div>
                          </div>
                        </a>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="box features-1">
                      <div class="gen-comp-plan">
                        <a href="/OLDROIIncome">
                          <div class="gcp-description">
                            <div class="gcp-title">Total Old Trading Bonus</div>
                            <div class="gcp-income">
                              <span class="cur1"> {dash.OldTradingBonus}</span>
                            </div>
                          </div>
                        </a>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="box features-1">
                      <div class="gen-comp-plan">
                        <a href="/OLDROIIncome">
                          <div class="gcp-description">
                            <div class="gcp-title">Today Old Trading Bonus</div>
                            <div class="gcp-income">
                              <span class="cur1">{dash.T_OldTradingBonus}</span>
                            </div>
                          </div>
                        </a>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="box features-1">
                      <div class="gen-comp-plan">
                        <a href="/IntroductionBonus">
                          <div class="gcp-description">
                            <div class="gcp-title">
                              Total Old Introduction Bonus
                            </div>
                            <div class="gcp-income">
                              <span class="cur1">
                                {" "}
                                {dash.OldIntroductionBonus}
                              </span>
                            </div>
                          </div>
                        </a>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="box features-1">
                      <div class="gen-comp-plan">
                        <a href="/IntroductionBonus">
                          <div class="gcp-description">
                            <div class="gcp-title">
                              Today Old Introduction Bonus
                            </div>
                            <div class="gcp-income">
                              <span class="cur1">
                                {dash.T_OldIntroductionBonus}
                              </span>
                            </div>
                          </div>
                        </a>
                      </div>
                    </div>
                  </div>
                  {/* <div class="col-md-6">
                    <div class="box features-1">
                      <div class="gen-comp-plan">
                        <a href="Withdrawal_History">
                          <div class="gcp-description">
                            <div class="gcp-title">
                              Total Pending Withdrawal
                            </div>
                            <div class="gcp-income">
                              <span class="cur1">
                                {dash.totalPendingWithdrawal}
                              </span>
                            </div>
                          </div>
                        </a>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="box features-1">
                      <div class="gen-comp-plan">
                        <a href="Withdrawal_History">
                          <div class="gcp-description">
                            <div class="gcp-title">
                              Today Pending Withdrawal
                            </div>
                            <div class="gcp-income">
                              <span class="cur1">
                                {dash.todayPendingWithdrawal}
                              </span>
                            </div>
                          </div>
                        </a>
                      </div>
                    </div>
                  </div> */}
                  <div class="col-md-6">
                    <div class="box features-1">
                      <div class="gen-comp-plan">
                        <a href="#">
                          <div class="gcp-description">
                            <div class="gcp-title">Total Income</div>
                            <div class="gcp-income">
                              <span class="cur1">{dash.totalIncome}</span>
                            </div>
                          </div>
                        </a>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="box features-1">
                      <div class="gen-comp-plan">
                        <a href="#">
                          <div class="gcp-description">
                            <div class="gcp-title">Today Income</div>
                            <div class="gcp-income">
                              <span class="cur1">{dash.todayIncome}</span>
                            </div>
                          </div>
                        </a>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="box features-1">
                      <div class="gen-comp-plan">
                        <a href="Withdrawal_History">
                          <div class="gcp-description">
                            <div class="gcp-title">Total Withdrawal</div>
                            <div class="gcp-income">
                              <span class="cur1"> {dash.totalWithdrawal}</span>
                            </div>
                          </div>
                        </a>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="box features-1">
                      <div class="gen-comp-plan">
                        <a href="Withdrawal_History">
                          <div class="gcp-description">
                            <div class="gcp-title">Today Withdrawal</div>
                            <div class="gcp-income">
                              <span class="cur1">{dash.todayWithdrawal}</span>
                            </div>
                          </div>
                        </a>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="box features-1">
                      <div class="gen-comp-plan">
                        <a href="#">
                          <div class="gcp-description">
                            <div class="gcp-title">Total Net Income</div>
                            <div class="gcp-income">
                              <span class="cur1">{dash.totalnetIncome}</span>
                            </div>
                          </div>
                        </a>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="box features-1">
                      <div class="gen-comp-plan">
                        <a href="#">
                          <div class="gcp-description">
                            <div class="gcp-title">Today Net Income</div>
                            <div class="gcp-income">
                              <span class="cur1">{dash.todaynetIncome}</span>
                            </div>
                          </div>
                        </a>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="box features-1">
                      <div class="gen-comp-plan">
                        <a href="#">
                          <div class="gcp-description">
                            <div class="gcp-title">Total Fund Transfer</div>
                            <div class="gcp-income">
                              <span class="cur1">{dash.FundTransfer}</span>
                            </div>
                          </div>
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </>
      {/* ) : (
        <>
          <div id="wrapper">
            <div class="content-page page_scroll_y">
              <div class="content">
                <div class="container">
                  <div class="row">
                    <h3>Welcome SubAdmin </h3>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </>
      )} */}
    </div>
  );
}

export default Dashboard;
